module.exports = __webpack_public_path__ + "img/Group 20.a472b8cd.svg";